import { APP_NAME } from '@sharpe/shared/config';
import { SharpeLogo } from '@sharpe/ui/components';
import Link from '@/components/smart-link';
import { Email } from '@carbon/icons-react';

export default function VerifyRequestPage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-md space-y-8 p-8 text-center">
        <SharpeLogo size={36} className="mx-auto" />

        <div className="w-16 h-16 mx-auto rounded-full bg-success/10 flex items-center justify-center">
          <Email size={32} className="text-muted-foreground" />
        </div>

        <div>
          <h2 className="text-2xl font-semibold">Check your email</h2>
          <p className="mt-4 text-muted-foreground">
            A sign-in link has been sent to your email address. Click the link to sign in to{' '}
            {APP_NAME}.
          </p>
          <p className="mt-2 text-sm text-muted-foreground">
            The link expires in 30 minutes. If you don&apos;t see the email, check your spam folder.
          </p>
        </div>

        <div className="pt-4">
          <Link href="/auth/signin" className="text-sm text-primary hover:underline">
            Use a different email
          </Link>
        </div>
      </div>
    </div>
  );
}
